import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { general_Search_str, suggest_CloseCircleFill_str } from '@zenlayer/zen-design-icons';
import { useCreation, useDebounce, useFocusWithin, useUpdateEffect } from 'ahooks';
import classnames from 'classnames';
import { mapObjIndexed, omit, uniqWith, without } from 'ramda';
import { useRef, useState } from 'react';
import { isNumber } from '../_util/defineType';
import { generateUuid, pickDomAttrs, sortWithKey } from '../_util/utils';
import Chips from '../chips';
import Dropdown from '../dropdown';
import { useConfig } from '../hooks/useConfig';
import SvgIcon from '../svg-icon';
import Menu from '../menu';
import { NotFoundContent } from '../select';
import Tag from '../tag';
import Typography from '../typography';
import Content, { ItemLabel } from './content';
import './style/index';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getValueObject(options, value) {
  let region = null;
  let city = null;
  let zone = null;
  if (value) {
    options.some(r => {
      var _r$children;
      return (_r$children = r.children) === null || _r$children === void 0 ? void 0 : _r$children.some(c => {
        var _c$children;
        return (_c$children = c.children) === null || _c$children === void 0 ? void 0 : _c$children.some(z => {
          if (z.key === value) {
            region = r;
            city = c;
            zone = z;
            return true;
          }
          return false;
        });
      });
    });
  }
  return region && city && zone ? {
    region,
    city,
    zone
  } : undefined;
}
function matchKeyword(keyword, matches) {
  if (!keyword) {
    return true;
  }
  return matches.some(k => {
    if (!k) {
      return false;
    }
    return k.toLowerCase().includes(keyword.toLowerCase());
  });
}
const ALL_REGION_KEY = 'ALL_REGION';
function LocationPicker(props) {
  const {
    mode = 'zone',
    width,
    height,
    defaultValue: _defaultValue,
    value: _value,
    options,
    defaultActiveFilterKeys,
    filterOptions,
    searchPlaceholder,
    extraElement,
    noData,
    columnWidth,
    extraColumn,
    replaceLocal,
    onChange,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-locationPicker");
  const attrs = pickDomAttrs(restProps);
  const {
    locale: {
      LocationPicker: LocationPickerLocale
    }
  } = useConfig();
  const localText = useCreation(() => {
    let text = LocationPickerLocale;
    if (replaceLocal) {
      text = mapObjIndexed((value, key) => {
        return replaceLocal[key] || value;
      }, LocationPickerLocale);
    }
    text = mapObjIndexed(value => {
      var _context, _context2;
      return _replaceAllInstanceProperty(_context = _replaceAllInstanceProperty(_context2 = _replaceAllInstanceProperty(value).call(value, '{region}', text.region)).call(_context2, '{city}', text.city)).call(_context, '{zone}', text.zone);
    }, text);
    return text;
  }, [JSON.stringify(LocationPickerLocale), JSON.stringify(replaceLocal)]);
  const searchWrapRef = useRef(null);
  const searchInputRef = useRef(null);
  const searchFocused = useFocusWithin(searchWrapRef);
  const [searchKeyword, setSearchKeyword] = useState('');
  const debouncedKeyword = useDebounce(searchKeyword, {
    wait: 200
  });
  const [filterValue, setFilterValue] = useState(defaultActiveFilterKeys !== null && defaultActiveFilterKeys !== void 0 ? defaultActiveFilterKeys : []);
  const [value, setValue] = useState(_value !== null && _value !== void 0 ? _value : _defaultValue);
  const onSelect = v => {
    setValue(v.zone.key);
    onChange === null || onChange === void 0 || onChange(v.zone.key, v);
  };
  const allRegions = useCreation(() => {
    if (!options) {
      return [];
    }
    const regions = sortWithKey('label', options).flatMap(region => {
      const cities = sortWithKey('label', region.children).flatMap(city => {
        const ANCESTORS = {
          region,
          city
        };
        const zones = mode === 'zone' ? sortWithKey('index', sortWithKey('label', city.children)).flatMap(zone => {
          if (zone.key) {
            return [{
              ...zone,
              ANCESTORS
            }];
          }
          return [];
        }) : [{
          ...omit(['children'], city),
          ANCESTORS
        }];
        if (zones.length) {
          return [{
            ...city,
            children: zones
          }];
        }
        return [];
      });
      if (cities.length) {
        return [{
          ...region,
          children: cities
        }];
      }
      return [];
    });
    return regions;
  }, [options, mode]);
  const filteredRegions = useCreation(() => {
    var _filterOptions$filter;
    const all = {
      key: ALL_REGION_KEY,
      label: 'All',
      children: []
    };
    const activeFilterOptions = (_filterOptions$filter = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.filter(item => filterValue.includes(item.key))) !== null && _filterOptions$filter !== void 0 ? _filterOptions$filter : [];
    const regions = allRegions.flatMap(region => {
      const cities = region.children.flatMap(city => {
        var _city$labelSuffix, _city$discount, _city$stockLimited;
        const cityLabelSuffix = (_city$labelSuffix = city.labelSuffix) !== null && _city$labelSuffix !== void 0 ? _city$labelSuffix : [];
        const zones = city.children.flatMap(zone => {
          var _zone$labelSuffix$sor, _zone$labelSuffix;
          const matchedFilter = activeFilterOptions.length ? activeFilterOptions.every(f => {
            return f.onMatch({
              region,
              city,
              zone
            });
          }) : true;
          if (!matchedFilter) {
            return [];
          }
          const zoneLabelSuffix = (_zone$labelSuffix$sor = (_zone$labelSuffix = zone.labelSuffix) === null || _zone$labelSuffix === void 0 ? void 0 : _zone$labelSuffix.sort((a, b) => a.index - b.index)) !== null && _zone$labelSuffix$sor !== void 0 ? _zone$labelSuffix$sor : [];
          if (zoneLabelSuffix.length) {
            zoneLabelSuffix.forEach(it => {
              if (it.showInCitySuffix) {
                cityLabelSuffix.push(it);
              }
            });
          }
          return [{
            ...zone,
            discount: isNumber(zone.discount) ? zone.discount >= 0 && zone.discount < 100 ? zone.discount : false : !!zone.discount,
            labelSuffix: zoneLabelSuffix
          }];
        });
        return zones.length ? [{
          ...city,
          discount: (_city$discount = city.discount) !== null && _city$discount !== void 0 ? _city$discount : zones.some(z => z.discount || typeof z.discount === 'number'),
          stockLimited: (_city$stockLimited = city.stockLimited) !== null && _city$stockLimited !== void 0 ? _city$stockLimited : zones.some(z => z.stockLimited),
          labelSuffix: uniqWith((a, b) => a.index === b.index, cityLabelSuffix).sort((a, b) => a.index - b.index),
          children: zones
        }] : [];
      });
      if (cities.length) {
        all.children = [...all.children, ...cities];
        return [{
          ...region,
          children: cities
        }];
      }
      return [];
    });
    all.children = sortWithKey('label', all.children);
    return regions.length ? [all, ...regions] : [];
  }, [allRegions, filterValue]);
  const searchDropdownContent = useCreation(() => {
    if (!debouncedKeyword) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }
    const matchedCities = [];
    const matchedZones = [];
    filteredRegions.forEach(region => {
      if (region.key === ALL_REGION_KEY) {
        return;
      }
      region.children.forEach(city => {
        var _city$keywords;
        const cityMatched = typeof city.keywords === 'boolean' ? city.keywords : matchKeyword(debouncedKeyword, [city.label].concat((_city$keywords = city.keywords) !== null && _city$keywords !== void 0 ? _city$keywords : []));
        if (cityMatched) {
          matchedCities.push({
            label: /*#__PURE__*/_jsx(ItemLabel, {
              label: city.label,
              labelSuffix: city.labelSuffix,
              discount: city.discount,
              stockLimited: city.stockLimited,
              localText: localText
            }),
            key: [region.key, city.key].join('/'),
            disabled: city.disabled,
            onClick: () => {
              updateContentKey();
              onSelect({
                region,
                city,
                zone: city.children[0]
              });
            }
          });
        }
        if (mode === 'zone') {
          city.children.forEach(zone => {
            var _zone$keywords;
            const zoneMatched = typeof zone.keywords === 'boolean' ? zone.keywords : matchKeyword(debouncedKeyword, [zone.label].concat((_zone$keywords = zone.keywords) !== null && _zone$keywords !== void 0 ? _zone$keywords : []));
            if (zoneMatched) {
              matchedZones.push({
                label: /*#__PURE__*/_jsx(ItemLabel, {
                  label: [city.label, zone.label].join(' / '),
                  labelSuffix: zone.labelSuffix,
                  discount: zone.discount,
                  stockLimited: zone.stockLimited,
                  localText: localText
                }),
                key: [region.key, city.key, zone.key].join('/'),
                disabled: zone.disabled || city.disabled,
                onClick: () => {
                  updateContentKey();
                  onSelect({
                    region,
                    city,
                    zone
                  });
                }
              });
            }
          });
        }
      });
    });
    if (matchedCities.length > 0 || matchedZones.length > 0) {
      let items = [];
      if (matchedCities.length > 0) {
        items.push({
          type: 'group',
          label: localText.city,
          children: matchedCities
        });
      }
      if (matchedZones.length > 0) {
        items.push({
          type: 'group',
          label: localText.zone,
          children: matchedZones
        });
      }
      return /*#__PURE__*/_jsx(Menu, {
        className: "search-dropdown",
        items: items
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: "search-dropdown-nodata",
      children: /*#__PURE__*/_jsx(NotFoundContent, {})
    });
  }, [filteredRegions, mode, debouncedKeyword, localText]);
  const activeItem = useCreation(() => {
    return getValueObject(allRegions, value);
  }, [value, allRegions]);
  const [activeTab, setActiveTab] = useState(ALL_REGION_KEY);
  const contentKeyRef = useRef(generateUuid());
  const updateContentKey = () => {
    contentKeyRef.current = generateUuid();
  };
  const onActiveTabChange = (tab, reload) => {
    if (reload) {
      updateContentKey();
    }
    setActiveTab(tab);
  };
  const content = useCreation(() => {
    var _filteredRegions$find, _filteredRegions$find2, _cities$find$children, _cities$find;
    if (!activeTab) {
      return {
        showZoneColumn: false,
        element: null
      };
    }
    const cities = (_filteredRegions$find = (_filteredRegions$find2 = filteredRegions.find(_ref => {
      let {
        key
      } = _ref;
      return key === activeTab;
    })) === null || _filteredRegions$find2 === void 0 ? void 0 : _filteredRegions$find2.children) !== null && _filteredRegions$find !== void 0 ? _filteredRegions$find : [];
    const zones = (_cities$find$children = (_cities$find = cities.find(_ref2 => {
      let {
        key
      } = _ref2;
      return key === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.city.key);
    })) === null || _cities$find === void 0 ? void 0 : _cities$find.children) !== null && _cities$find$children !== void 0 ? _cities$find$children : [];
    const showZoneColumn = mode === 'zone' && zones.length > 0;
    return {
      showZoneColumn: mode === 'zone' && zones.length > 0,
      element: /*#__PURE__*/_jsx(Content, {
        value: activeItem,
        cities: cities,
        zones: zones,
        extraElement: extraElement,
        zoneColumnWidth: columnWidth === null || columnWidth === void 0 ? void 0 : columnWidth.zone,
        showZoneColumn: showZoneColumn,
        localText: localText,
        baseClassName: baseClassName,
        onChange: d => {
          onSelect(d);
        }
      }, contentKeyRef.current)
    };
  }, [filteredRegions, activeTab, activeItem, mode, columnWidth === null || columnWidth === void 0 ? void 0 : columnWidth.zone, extraElement, localText]);
  useUpdateEffect(() => {
    if (_value !== value) {
      setValue(_value);
      onActiveTabChange(ALL_REGION_KEY, true);
    }
  }, [_value]);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classnames(baseClassName, className),
    style: {
      ...style,
      width
    },
    children: [!!(filterOptions !== null && filterOptions !== void 0 && filterOptions.length) && /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "-filter"),
      children: [/*#__PURE__*/_jsx("div", {
        className: "".concat(baseClassName, "-filter--l"),
        children: localText.filterLabel
      }), /*#__PURE__*/_jsx("div", {
        className: "".concat(baseClassName, "-filter--r"),
        children: /*#__PURE__*/_jsx(Chips.Group, {
          multiple: true,
          size: "s",
          type: "filled",
          value: filterValue.length ? filterValue : ['all'],
          onChange: (_, opt) => {
            if ((opt === null || opt === void 0 ? void 0 : opt.value) === 'all') {
              setFilterValue([]);
            } else {
              setFilterValue(filterValue.includes(opt === null || opt === void 0 ? void 0 : opt.value) ? without([opt === null || opt === void 0 ? void 0 : opt.value], filterValue) : [...filterValue, opt === null || opt === void 0 ? void 0 : opt.value]);
            }
            updateContentKey();
          },
          children: [{
            key: 'all',
            value: 'all',
            label: localText.filterTagAll
          }, ...filterOptions].map(item => /*#__PURE__*/_jsx(Chips, {
            value: item.key,
            children: item.label
          }, item.key))
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--main"),
      style: {
        height: height !== null && height !== void 0 ? height : 400
      },
      children: [/*#__PURE__*/_jsx("div", {
        ref: searchWrapRef,
        className: "".concat(baseClassName, "--search"),
        children: /*#__PURE__*/_jsx(Dropdown, {
          open: searchFocused && !!debouncedKeyword,
          dropdownRender: () => searchDropdownContent,
          align: {
            offset: [0, 1]
          },
          destroyPopupOnHide: true,
          getPopupContainer: triggerNode => triggerNode.parentNode,
          children: /*#__PURE__*/_jsxs("div", {
            className: "search-input",
            children: [/*#__PURE__*/_jsx("span", {
              className: "search-icon",
              onClick: () => {
                var _searchInputRef$curre;
                return (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus();
              },
              children: /*#__PURE__*/_jsx(SvgIcon, {
                svgStr: general_Search_str,
                block: true
              })
            }), /*#__PURE__*/_jsx("input", {
              ref: searchInputRef,
              type: "text",
              placeholder: searchPlaceholder !== null && searchPlaceholder !== void 0 ? searchPlaceholder : mode === 'city' ? localText.searchCityPlaceholder : localText.searchZonePlaceholder,
              value: searchKeyword,
              onBlur: () => {
                setSearchKeyword('');
              },
              onChange: e => {
                if (activeTab !== ALL_REGION_KEY) {
                  setActiveTab(ALL_REGION_KEY);
                }
                setSearchKeyword(e.target.value);
              }
            }), searchFocused && !!debouncedKeyword && /*#__PURE__*/_jsx("span", {
              className: "search-icon",
              onMouseDown: e => {
                e.preventDefault();
                setSearchKeyword('');
              },
              children: /*#__PURE__*/_jsx(SvgIcon, {
                svgStr: suggest_CloseCircleFill_str,
                block: true
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "".concat(baseClassName, "--lp-body"),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "".concat(baseClassName, "--lp-selection"),
          children: [/*#__PURE__*/_jsxs("div", {
            className: "".concat(baseClassName, "--header"),
            children: [/*#__PURE__*/_jsx("div", {
              className: "column-title region",
              style: {
                width: columnWidth === null || columnWidth === void 0 ? void 0 : columnWidth.region
              },
              children: localText.region
            }), /*#__PURE__*/_jsx("div", {
              className: "column-title city",
              children: localText.city
            }), content.showZoneColumn && /*#__PURE__*/_jsx("div", {
              className: "column-title zone",
              style: {
                width: columnWidth === null || columnWidth === void 0 ? void 0 : columnWidth.zone
              },
              children: localText.zone
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "".concat(baseClassName, "--body"),
            children: filteredRegions !== null && filteredRegions !== void 0 && filteredRegions.length ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("div", {
                className: "".concat(baseClassName, "--column region"),
                style: {
                  width: columnWidth === null || columnWidth === void 0 ? void 0 : columnWidth.region
                },
                children: /*#__PURE__*/_jsx("div", {
                  className: "column-inner",
                  children: filteredRegions.map(item => {
                    const active = activeTab === item.key;
                    return /*#__PURE__*/_jsx("div", {
                      className: classnames('column-item', {
                        active
                      }),
                      onMouseDown: e => {
                        e.preventDefault();
                        if (active) {
                          return;
                        }
                        const valueExists = item.key === ALL_REGION_KEY || activeTab === ALL_REGION_KEY ? item.children.some(c => c.children.some(z => z.key === value)) : false;
                        if (!valueExists) {
                          var _item$children$find, _city$children$find;
                          const city = (_item$children$find = item.children.find(c => !c.disabled)) !== null && _item$children$find !== void 0 ? _item$children$find : item.children[0];
                          const zone = (_city$children$find = city.children.find(z => !z.disabled)) !== null && _city$children$find !== void 0 ? _city$children$find : city.children[0];
                          onSelect({
                            ...zone.ANCESTORS,
                            zone
                          });
                        }
                        onActiveTabChange(item.key, item.key !== activeTab);
                      },
                      children: /*#__PURE__*/_jsx(ItemLabel, {
                        label: item.label,
                        labelSuffix: [{
                          index: 0,
                          element: /*#__PURE__*/_jsx(Tag, {
                            style: {
                              pointerEvents: 'none'
                            },
                            children: item.children.length
                          })
                        }],
                        localText: localText
                      })
                    }, item.key);
                  })
                })
              }), content.element]
            }) : /*#__PURE__*/_jsx("div", {
              className: "".concat(baseClassName, "--nodata"),
              children: (options === null || options === void 0 ? void 0 : options.length) === 0 ? noData !== null && noData !== void 0 ? noData : /*#__PURE__*/_jsx(NotFoundContent, {}) : filterValue.length ? /*#__PURE__*/_jsxs("div", {
                className: "".concat(baseClassName, "--nodata--filter"),
                children: [/*#__PURE__*/_jsx(Typography.Text, {
                  size: "16-20",
                  children: localText.noData
                }), /*#__PURE__*/_jsxs(Typography.Text, {
                  size: "12-16",
                  children: [/*#__PURE__*/_jsx("span", {
                    children: localText.noDataTips1
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
                    children: localText.noDataTips2
                  }), /*#__PURE__*/_jsx("a", {
                    onClick: () => {
                      setFilterValue([]);
                    },
                    children: localText.noDataTips3
                  }), /*#__PURE__*/_jsx("span", {
                    children: localText.noDataTips4
                  })]
                })]
              }) : null
            })
          })]
        }), extraColumn]
      })]
    })]
  });
}
export default LocationPicker;